<template>
    <div class="page-container">
        <!-- 工具条 -->
        <div class="toolbar">
            <div class="left">
                <el-button round @click="fetchList" :loading="loading">
                    <el-icon>
                        <Refresh />
                    </el-icon> 刷新
                </el-button>

                <el-input v-model="search.keyword" placeholder="按素材名/文案分组/成品分组/错误信息 搜索" clearable style="width: 360px"
                    @keyup.enter="doSearch" class="ml10">
                    <template #prefix>
                        <el-icon>
                            <Search />
                        </el-icon>
                    </template>
                </el-input>

                <el-select v-model="search.status" placeholder="状态筛选" clearable style="width: 160px" class="ml10"
                    @change="doSearch">
                    <el-option :value="1" label="正常" />
                    <el-option :value="2" label="失败" />
                </el-select>

                <el-button type="primary" class="ml10" @click="doSearch">
                    <el-icon>
                        <Search />
                    </el-icon> 搜索
                </el-button>

                <!-- 批量删除 -->
                <el-popconfirm v-if="selectedIds.length" :title="`确认删除选中的 ${selectedIds.length} 条记录吗？`"
                    @confirm="doBatchDelete">
                    <template #reference>
                        <el-button type="danger" class="ml10" :disabled="!selectedIds.length" :loading="batchDeleting">
                            批量删除<span v-if="selectedIds.length">（{{ selectedIds.length }}）</span>
                        </el-button>
                    </template>
                </el-popconfirm>
            </div>

            <div class="right">
                <el-button type="success" round @click="openAdd">
                    <el-icon>
                        <Plus />
                    </el-icon> 添加
                </el-button>
            </div>
        </div>

        <!-- 列表 -->
        <el-table :data="list" border stripe v-loading="loading" style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="48" />
            <el-table-column prop="id" label="ID" width="80" />

            <!-- 用名称映射，而不是直接显示ID -->
            <el-table-column label="开始素材" min-width="160" show-overflow-tooltip>
                <template #default="s">{{ scName(s.row.video_start_id) || '—' }}</template>
            </el-table-column>
            <el-table-column label="中间素材" min-width="160" show-overflow-tooltip>
                <template #default="s">{{ scName(s.row.video_middle_id) || '—' }}</template>
            </el-table-column>
            <el-table-column label="结束素材" min-width="160" show-overflow-tooltip>
                <template #default="s">{{ scName(s.row.video_end_id) || '—' }}</template>
            </el-table-column>
            <el-table-column label="文案分组" min-width="160" show-overflow-tooltip>
                <template #default="s">{{ wenanName(s.row.wenan_id) || '—' }}</template>
            </el-table-column>
            <el-table-column label="成品分组" min-width="160" show-overflow-tooltip>
                <template #default="s">{{ cpName(s.row.video_cp_id) || '—' }}</template>
            </el-table-column>

            <el-table-column prop="jianji_num" label="剪辑数量" width="110" />
            <el-table-column label="状态" width="110">
                <template #default="s">
                    <el-tag :type="s.row.status === 1 ? 'success' : 'danger'">
                        {{ s.row.status === 1 ? '正常' : '失败' }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="error_message" label="错误信息" min-width="200" show-overflow-tooltip />
            <el-table-column prop="create_time" label="创建时间" width="180" />
            <el-table-column prop="update_time" label="更新时间" width="180" />

            <el-table-column label="操作" width="200" fixed="right">
                <template #default="s">
                    <el-button type="primary" size="small" @click="copyRow(s.row)">
                        <el-icon>
                            <DocumentCopy />
                        </el-icon>复制
                    </el-button>


                    <el-popconfirm title="确认删除该记录吗？" @confirm="delOne(s.row.id)">
                        <template #reference>
                            <el-button type="danger" size="small">
                                <el-icon>
                                    <Delete />
                                </el-icon>删除
                            </el-button>
                        </template>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pager">
            <el-pagination v-model:current-page="pager.page" v-model:page-size="pager.pageSize" :total="pager.total"
                :page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="fetchList"
                @current-change="fetchList" />
        </div>

        <!-- 新增弹窗 -->
        <el-dialog v-model="dialogVisible" title="新增短视频剪辑任务" width="720px" :close-on-click-modal="false"
            destroy-on-close>
            <el-form ref="formRef" :model="form" :rules="rules" label-width="120px">
                <el-form-item label="开始素材" prop="video_start_id">
                    <el-select v-model="form.video_start_id" filterable clearable placeholder="请选择开始素材"
                        style="width: 100%" :loading="loadingSources.sc">
                        <el-option v-for="it in sources.sc" :key="`sc-start-${it.id}`" :label="it.video_name"
                            :value="String(it.id)" />
                    </el-select>
                </el-form-item>

                <el-form-item label="中间素材" prop="video_middle_id">
                    <el-select v-model="form.video_middle_id" filterable clearable placeholder="请选择中间素材"
                        style="width: 100%" :loading="loadingSources.sc">
                        <el-option v-for="it in sources.sc" :key="`sc-middle-${it.id}`" :label="it.video_name"
                            :value="String(it.id)" />
                    </el-select>
                </el-form-item>

                <el-form-item label="结束素材" prop="video_end_id">
                    <el-select v-model="form.video_end_id" filterable clearable placeholder="请选择结束素材"
                        style="width: 100%" :loading="loadingSources.sc">
                        <el-option v-for="it in sources.sc" :key="`sc-end-${it.id}`" :label="it.video_name"
                            :value="String(it.id)" />
                    </el-select>
                </el-form-item>

                <el-form-item label="文案分组" prop="wenan_id">
                    <el-select v-model="form.wenan_id" filterable clearable placeholder="请选择文案分组" style="width: 100%"
                        :loading="loadingSources.wenan">
                        <el-option v-for="it in sources.wenan" :key="`wn-${it.id}`" :label="it.wenan_name"
                            :value="String(it.id)" />
                    </el-select>
                </el-form-item>

                <el-form-item label="成品分组" prop="video_cp_id">
                    <el-select v-model="form.video_cp_id" filterable clearable placeholder="请选择视频成品分组"
                        style="width: 100%" :loading="loadingSources.cp">
                        <el-option v-for="it in sources.cp" :key="`cp-${it.id}`" :label="it.video_name"
                            :value="String(it.id)" />
                    </el-select>
                </el-form-item>

                <el-form-item label="剪辑数量" prop="jianji_num">
                    <el-input v-model.number="form.jianji_num" type="number" :min="1" placeholder="请输入剪辑数量（整数）" />
                </el-form-item>

                <el-form-item label="状态" prop="status">
                    <el-radio-group v-model="form.status">
                        <el-radio :value="1">正常</el-radio>
                        <el-radio :value="2">失败</el-radio>
                    </el-radio-group>
                </el-form-item>

                <!-- 按你的要求：去掉“错误信息”输入框 -->
            </el-form>

            <template #footer>
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="submitting" @click="submit">提交</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import Cookies from 'js-cookie'
import config from '@/config.js'
import { Plus, Refresh, Search, Delete, DocumentCopy } from '@element-plus/icons-vue'

export default {
    name: 'VideoCutTask',
    components: { Plus, Refresh, Search, Delete, DocumentCopy },
    data() {
        return {
            loading: false,
            batchDeleting: false,
            list: [],
            pager: { page: 1, pageSize: 10, total: 0 },
            search: { keyword: '', status: '' },

            selectedIds: [],
            dialogVisible: false,
            submitting: false,

            // 下拉源
            sources: {
                sc: [],     // 素材（开始/中间/结束公用）
                wenan: [],  // 文案分组
                cp: []      // 成品分组
            },
            loadingSources: {
                sc: false,
                wenan: false,
                cp: false
            },

            form: {
                video_start_id: '',
                video_middle_id: '',
                video_end_id: '',
                wenan_id: '',
                video_cp_id: '',
                jianji_num: 1,
                status: 1
            },
            rules: {
                jianji_num: [{ required: true, type: 'number', message: '请输入剪辑数量', trigger: 'blur' }],
                status: [{ required: true, type: 'number', message: '请选择状态', trigger: 'change' }]
            }
        }
    },
    computed: {
        userInfo() { return JSON.parse(Cookies.get('user_info') || '{}') },
        apiBase() { return `${config.BASE_URL}/shop/api` },
    },
    mounted() {
        this.fetchSources()
        this.fetchList()
    },
    methods: {
        // ========== 列表 ==========
        async fetchList() {
            const action = (this.search.keyword || this.search.status !== '') ? 'search' : 'list'
            try {
                this.loading = true
                const payload = {
                    action,
                    store_id: this.userInfo.id,
                    page: this.pager.page,
                    page_size: this.pager.pageSize
                }
                if (this.search.keyword) payload.keyword = this.search.keyword
                if (this.search.status !== '') payload.status = this.search.status

                const { data } = await axios.post(`${this.apiBase}/video_cut_task.php`, payload)
                this.list = data.data || []
                this.pager.total = data.pagination ? data.pagination.total : (this.list?.length || 0)

                // 越界回退一页
                if (!this.list.length && this.pager.page > 1) {
                    this.pager.page = this.pager.page - 1
                    await this.fetchList()
                }
                this.selectedIds = []
            } catch (e) {
                console.error(e)
                this.$message.error('获取列表失败')
            } finally {
                this.loading = false
            }
        },
        doSearch() {
            this.pager.page = 1
            this.fetchList()
        },
        handleSelectionChange(rows) {
            this.selectedIds = rows.map(r => r.id)
        },
        async delOne(id) {
            try {
                const { data } = await axios.post(`${this.apiBase}/video_cut_task.php`, {
                    action: 'delete',
                    id,
                    store_id: this.userInfo.id
                })
                if (data.success) {
                    this.$message.success('已删除')
                    this.fetchList()
                } else {
                    this.$message.error(data.error || '删除失败')
                }
            } catch (e) {
                this.$message.error('删除失败')
            }
        },
        async doBatchDelete() {
            if (!this.selectedIds.length) return
            try {
                this.batchDeleting = true
                const { data } = await axios.post(`${this.apiBase}/video_cut_task.php`, {
                    action: 'batch_delete',
                    store_id: this.userInfo.id,
                    ids: this.selectedIds
                })
                if (data.success) {
                    this.$message.success('批量删除成功')
                    await this.fetchList()
                } else {
                    this.$message.error(data.error || '批量删除失败')
                }
            } catch {
                this.$message.error('批量删除失败')
            } finally {
                this.batchDeleting = false
            }
        },

        // ========== 弹窗 & 提交 ==========
        openAdd() {
            this.dialogVisible = true
            this.$nextTick(() => this.$refs.formRef?.clearValidate?.())
            // 重置表单
            this.form = {
                video_start_id: '',
                video_middle_id: '',
                video_end_id: '',
                wenan_id: '',
                video_cp_id: '',
                jianji_num: 1,
                status: 1
            }
        },
        submit() {
            this.$refs.formRef.validate(async (ok) => {
                if (!ok) return
                try {
                    this.submitting = true
                    const payload = {
                        action: 'add',
                        store_id: this.userInfo.id,
                        video_start_id: this.form.video_start_id || null,
                        video_middle_id: this.form.video_middle_id || null,
                        video_end_id: this.form.video_end_id || null,
                        wenan_id: this.form.wenan_id || null,
                        video_cp_id: this.form.video_cp_id || null,
                        jianji_num: Number(this.form.jianji_num) || 1,
                        status: Number(this.form.status) || 1
                    }
                    const { data } = await axios.post(`${this.apiBase}/video_cut_task.php`, payload)
                    if (data.success) {
                        this.$message.success('新增成功')
                        this.dialogVisible = false
                        this.fetchList()
                    } else {
                        this.$message.error(data.error || '新增失败')
                    }
                } catch (e) {
                    console.error(e)
                    this.$message.error('新增失败')
                } finally {
                    this.submitting = false
                }
            })
        },

        // ========== 名称映射（id -> name，供列表显示） ==========
        scName(id) {
            if (!id) return ''
            const item = this.sources.sc.find(x => String(x.id) === String(id))
            return item ? item.video_name : ''
        },
        wenanName(id) {
            if (!id) return ''
            const item = this.sources.wenan.find(x => String(x.id) === String(id))
            return item ? item.wenan_name : ''
        },
        cpName(id) {
            if (!id) return ''
            const item = this.sources.cp.find(x => String(x.id) === String(id))
            return item ? item.video_name : ''
        },

        // ========== 复制现有行，打开新增弹窗可修改 ==========
        copyRow(row) {
            this.dialogVisible = true
            this.$nextTick(() => this.$refs.formRef?.clearValidate?.())
            this.form = {
                video_start_id: row.video_start_id || '',
                video_middle_id: row.video_middle_id || '',
                video_end_id: row.video_end_id || '',
                wenan_id: row.wenan_id || '',
                video_cp_id: row.video_cp_id || '',
                jianji_num: row.jianji_num || 1,
                status: row.status || 1
            }
        },

        // ========== 下拉源 ==========
        async fetchSources() {
            await Promise.all([
                this.fetchSC(),
                this.fetchWenan(),
                this.fetchCP()
            ])
        },
        async fetchSC() {
            try {
                this.loadingSources.sc = true
                const { data } = await axios.post(`${this.apiBase}/video_sc_management.php`, {
                    action: 'list_all',
                    store_id: this.userInfo.id
                })
                const rows = data?.data || []
                this.sources.sc = rows.map(r => ({ ...r, id: r.id }))
            } catch (e) {
                this.sources.sc = []
            } finally {
                this.loadingSources.sc = false
            }
        },
        async fetchWenan() {
            try {
                this.loadingSources.wenan = true
                const { data } = await axios.post(`${this.apiBase}/wenan_management.php`, {
                    action: 'list_all',
                    store_id: this.userInfo.id
                })
                const rows = data?.data || []
                this.sources.wenan = rows.map(r => ({ ...r, id: r.id }))
            } catch (e) {
                this.sources.wenan = []
            } finally {
                this.loadingSources.wenan = false
            }
        },
        async fetchCP() {
            try {
                this.loadingSources.cp = true
                const { data } = await axios.post(`${this.apiBase}/video_cp_management.php`, {
                    action: 'list_all',
                    store_id: this.userInfo.id
                })
                const rows = data?.data || []
                this.sources.cp = rows.map(r => ({ ...r, id: r.id }))
            } catch (e) {
                this.sources.cp = []
            } finally {
                this.loadingSources.cp = false
            }
        }
    }
}
</script>

<style scoped>
.page-container {
    padding: 12px 16px;
}

.toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.left,
.right {
    display: flex;
    align-items: center;
}

.ml10 {
    margin-left: 10px;
}

.pager {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
}
</style>